var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkuvaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "skuvault-logo",
    width: 1834.583,
    height: 385.864,
    viewBox: "0 0 1834.583 385.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M288.163,13.565h43.863L263.1,215.727h-39.9L154.918,13.565h45.187l43.863,153.353L288.163,13.565ZM392.872,59.732,341.421,215.561H297.227L369.454,13.393h47.823l71.565,202.168H443L392.872,59.732Zm96.8-46.168h42.875V131.959a70.587,70.587,0,0,0,4.946,30.506c5.112,11.379,16.16,16.985,33.31,16.985,16.985,0,28.034-5.607,33.146-16.985a70.079,70.079,0,0,0,4.947-30.506V13.565h42.875v118.56c0,21.438-3.3,38.255-10.057,50.13q-18.551,32.9-71.072,32.98c-34.958,0-58.7-10.885-71.237-32.98a104.969,104.969,0,0,1-10.057-50.13V13.565Zm186.338,0h42.208V179.285H819.137v36.282H676.007v-202Zm272.74,0V49.344H888.232V215.727h-42.38V49.344H785.165V13.565H948.747Z",
    transform: "translate(831.181 71.857)",
    fill: "#b8c0c4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M93.38,159.535a61.489,61.489,0,0,0,5.936,22.921,44.635,44.635,0,0,0,12.7,15.336,49.672,49.672,0,0,0,17.809,8.575,82.5,82.5,0,0,0,21.6,2.638,74.545,74.545,0,0,0,23.251-3.3,45.216,45.216,0,0,0,16-9.069,35.037,35.037,0,0,0,9.069-13.357,43.711,43.711,0,0,0,2.968-16,32.409,32.409,0,0,0-5.277-19.128,42.117,42.117,0,0,0-13.852-11.873,80.974,80.974,0,0,0-19.623-7.421q-11.131-2.721-22.757-5.442c-7.75-1.814-15.335-3.958-22.756-6.267a72.729,72.729,0,0,1-19.624-9.729A45.886,45.886,0,0,1,84.97,91.6a49.756,49.756,0,0,1-5.277-24.57,50.1,50.1,0,0,1,4.288-20.118A52.791,52.791,0,0,1,96.843,29.429,62.649,62.649,0,0,1,118.28,17.392a90.627,90.627,0,0,1,29.682-4.453,85.833,85.833,0,0,1,29.846,4.782,58.767,58.767,0,0,1,21.108,13.027,52.486,52.486,0,0,1,12.7,19.293A64,64,0,0,1,215.9,73.292H197.6a43.979,43.979,0,0,0-4.123-19.953,37.888,37.888,0,0,0-11.048-13.685,45.453,45.453,0,0,0-16-7.915,69.3,69.3,0,0,0-18.469-2.474,63.246,63.246,0,0,0-24.57,4.122,42.984,42.984,0,0,0-15.831,10.554,34.7,34.7,0,0,0-8.08,14.346,33.673,33.673,0,0,0-.824,15.666,27.415,27.415,0,0,0,7.915,15.665,50.032,50.032,0,0,0,15.17,9.729,107.224,107.224,0,0,0,19.788,6.1c7.256,1.649,14.513,3.3,21.932,4.947,7.42,1.814,14.676,3.957,21.766,6.266a66.906,66.906,0,0,1,18.634,9.894,45.454,45.454,0,0,1,13.029,15.829,52.852,52.852,0,0,1,4.947,24.241,52.825,52.825,0,0,1-19.293,43.534q-19.3,15.334-54.419,15.334a97.571,97.571,0,0,1-29.187-4.122A61.8,61.8,0,0,1,95.688,209a55.754,55.754,0,0,1-15.335-20.447,69.59,69.59,0,0,1-5.442-28.693H93.38Z",
    transform: "translate(401.814 69.347)",
    fill: "#70be67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M101.06,215.567V13.73h19.128V118.28L223.579,13.73h21.6L165.534,94.206,259.2,215.567H235.947l-84.1-109.655-31.661,31.661v77.994H101.06Z",
    transform: "translate(542.217 73.666)",
    fill: "#00b3b6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M126.422,13.73H145.55V134.107c0,25.065,4.618,43.039,14.017,54.087s24.4,16.491,45.183,16.491a80.169,80.169,0,0,0,27.7-4.287,41.712,41.712,0,0,0,18.3-13.193,54.654,54.654,0,0,0,10.057-22.1,141.928,141.928,0,0,0,3.133-31.166V13.73h19.128V139.714c0,26.384-6.6,46.5-19.458,60.353-13.027,14.016-32.65,20.942-58.7,20.942q-39.576,0-58.869-21.272c-12.862-14.181-19.293-34.3-19.293-60.025V13.73Z",
    transform: "translate(678.292 73.668)",
    fill: "#1986c7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,14.067V192.983l155.008-89.375Z",
    transform: "translate(0 75.474)",
    fill: "#70be67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M155.008,179.081V0L0,89.541Z",
    fill: "#00b3b6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M184.411,14.067,29.4,103.608l155.008,89.375V14.067Z",
    transform: "translate(157.756 75.474)",
    fill: "#1986c7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M184.411,89.541,29.4,0V179.081L184.411,89.541Z",
    transform: "translate(157.756)",
    fill: "#00b3b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M26.89,211.567,181.9,122.027,26.89,32.486Z",
    transform: "translate(144.273 174.297)",
    fill: "#1986c7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M157.547,32.486,2.539,122.027l155.008,89.541Z",
    transform: "translate(13.622 174.297)",
    fill: "#70be67"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M122.53,20.906V131.388L26.891,186.633V76.15Z",
    transform: "translate(144.278 112.167)",
    fill: "#b8c0c4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M107.649,186.633V76.15L11.839,20.906V131.388Z",
    transform: "translate(63.52 112.167)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M107.649,122.709l95.639-55.238L107.649,12.227,11.839,67.471Z",
    transform: "translate(63.52 65.601)",
    fill: "#dbdfe1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M298.077,30.427h1.938c2.269,0,4.113-.756,4.113-2.6,0-1.631-1.182-2.718-3.781-2.718a10.653,10.653,0,0,0-2.269.213Zm-.118,10.093h-4.112V22.746a35.5,35.5,0,0,1,6.83-.544,11.076,11.076,0,0,1,6.169,1.3,4.952,4.952,0,0,1,1.725,3.9,4.541,4.541,0,0,1-3.687,4.113v.213a5.174,5.174,0,0,1,3.238,4.328,13.893,13.893,0,0,0,1.3,4.444H305a14.948,14.948,0,0,1-1.419-4.328c-.307-1.938-1.394-2.813-3.663-2.813h-1.938v7.162Zm-10.943-9.313A13.759,13.759,0,0,0,300.892,45.39,13.61,13.61,0,0,0,314.435,31.3a13.719,13.719,0,1,0-27.417-.094Zm31.954,0A17.8,17.8,0,1,1,313.605,18.5a17.852,17.852,0,0,1,5.364,12.712Z",
    transform: "translate(1515.613 72.043)",
    fill: "#bbc3c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuvaultLogo);
export default __webpack_public_path__ + "static/media/skuvault-logo.407a7fcf3b9d80824679e000727dfbb6.svg";
export { ForwardRef as ReactComponent };